import { queryOptions } from '@tanstack/react-query'
import type { GetInsightsOptions } from '@/src/services/insights'
import { getInsight, getInsights } from '@/src/services/insights'

const INSIGHT_ROOT_QUERY_KEY = 'insights' as const

export const getInsightQuery = (id: string, enabled: boolean) =>
  queryOptions({
    queryKey: [INSIGHT_ROOT_QUERY_KEY, 'asset', id],
    queryFn: () => getInsight(id),
    enabled,
    staleTime: 1000 * 60 * 1, // 1 minute
  })

export const getInsightsQuery = (options: GetInsightsOptions) =>
  queryOptions({
    queryKey: [INSIGHT_ROOT_QUERY_KEY, 'list', options],
    queryFn: () => getInsights(options),
    staleTime: 1000 * 60 * 1, // 1 minute
  })
